import { USER_ROLES } from "./constants";

const ADMIN_RESTRICTED_EXACT_PATHS = new Set([
  // Trade Delegates
  "/tradedelegates-list",
  "/delegates-list",
  "/manage-delegates",
  "/add-trade-delegate-excel",

  // Onsite Module
  "/onsite-links",
  "/onsite",
  "/onsite-module",

  // Registration Form Builder
  "/form-links",
  "/registration-form-builder",
  "/registration-settings",
  "/registration-page-preview",
  "/registration-terms-conditions",
  "/registration-badge-preview",

  // Application Settings and its quick actions
  "/settings",
  "/banner-logo-settings",
  "/meta-data-editor",
  "/update-gtag",
  "/update-meta-pixel-tag",
  "/super-settings",
]);

const ADMIN_RESTRICTED_PATH_PREFIXES = [
  "/visitor-view/",
  "/onsite/",
  "/onsite-module/",
  "/registration-analytics-tracker/",
];

export const isAdminRestrictedPath = (pathname = "") => {
  const normalizedPath = pathname.length > 1
    ? pathname.replace(/\/+$/, "")
    : pathname;

  return (
    ADMIN_RESTRICTED_EXACT_PATHS.has(normalizedPath) ||
    ADMIN_RESTRICTED_PATH_PREFIXES.some((prefix) =>
      normalizedPath.startsWith(prefix)
    )
  );
};

export const isPathAllowedForRole = (pathname, role) =>
  role !== USER_ROLES.ADMIN || !isAdminRestrictedPath(pathname);
